export type LineOption = Partial<{
  uri: string
  startPoint: [number, number, number]
  endPoint: [number, number, number]
  color: string
  width: number
  tiling: number
  curve: number
  duration: number
  loop: boolean
  delay: number
}>

export type ButtleOption = Partial<{
  uri: string
  visible: boolean
  scale: [number, number, number]
  color: string
}>

export type PathItem = {
  from: [number, number, number]
  to: [number, number, number]
}

export type Option = {
  visible?: boolean
  style: string
  path: Array<object>
  line: LineOption
  bubble?: ButtleOption
}